import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  container: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    padding: 4,
    cursor: 'pointer',
    '&:hover $label, &:hover $count': {
      color: theme.primary,
    },
    '&:focus-visible': {
      outline: `1px solid ${theme.primary}`,
      outlineOffset: 2,
    },
  },
  label: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  count: {
    color: theme.textLight,
  },
  active: {
    borderBottom: `1px solid ${theme.primary}`,
    '& $label': {
      color: theme.primary,
      fontWeight: 500,
    },
    '& $count': {
      color: theme.primary,
    },
  },
}))

const QuickFilter = (props) => {
  const { name, label, count, active, onClick, customClass, dataQsId } = props
  const classes = useStyles()
  const handleClick = () => {
    onClick && onClick(name)
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClick()
    }
  }

  const containerClass = clsx(classes.container, customClass, active && classes.active)
  return (
    <div
      className={containerClass}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={0}
      aria-pressed={!!active}
      data-qs-id={dataQsId}>
      <label className={classes.label}>{label}</label>
      {count !== undefined && count !== null && <div className={classes.count}>{count}</div>}
    </div>
  )
}

QuickFilter.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  count: PropTypes.number,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  customClass: PropTypes.string,
  dataQsId: PropTypes.string,
}

export default QuickFilter
